<template>
  <StatusChip
    :entity="rev"
    :status="revStatus"
    :availableStatus="availableStatus"
    :isEditable="canEdit"
    :large="large"
    :showValidationIcons="showValidationIcons"
    @onChange="handleSelectStatus"
  />
</template>
<script>
import _ from 'lodash'
import revMixin from '@/mixins/revMixin'
import StatusChip from '../Core/StatusChip.vue'

export default {
  name: 'RevStatus',

  mixins: [revMixin],
  components: {
    StatusChip,
  },

  props: {
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    rev: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    showValidationIcons: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    revStatus() {
      return this.getRevStatus(this.rev)
    },

    isInReviewStatusEnabled() {
      return this.$isFeatureEnabled(this.$featuresKeys?.inReviewStatus)
    },

    availableStatus() {
      return _.compact([
        {
          value: this.$constants.revStatus.open,
          text: this.getStatusText(this.$constants.revStatus.open),
        },
        this.isInReviewStatusEnabled
          ? {
              value: this.$constants.revStatus.inReview,
              text: this.getStatusText(this.$constants.revStatus.inReview),
            }
          : null,
        {
          value: this.$constants.revStatus.inProgress,
          text: this.getStatusText(this.$constants.revStatus.inProgress),
        },
        {
          value: this.$constants.revStatus.completed,
          text: this.getStatusText(this.$constants.revStatus.completed),
        },
        {
          value: this.$constants.revStatus.onHold,
          text: this.getStatusText(this.$constants.revStatus.onHold),
        },
        {
          value: this.$constants.revStatus.canceled,
          text: this.getStatusText(this.$constants.revStatus.canceled),
        },
      ])
    },
  },

  methods: {
    getStatusText(status) {
      return this.$t(
        `common.rev_condition.${this.getStatusTranslationKey(status)}`
      )
    },

    getStatusTranslationKey(status) {
      return _.snakeCase(status)
    },

    handleSelectStatus(status) {
      this.$emit('onChange', status)
    },
  },
}
</script>
